<template>
  <div>
    <h5> Espacio utilizado en esta instalación: {{espacio}}</h5>
  </div>
</template>

<script>
import Entidad from '@/api/entidad'
export default {
  name: 'DashboardSuperadmin',
  computed: {
  },
  props: {
    titulo: {
      type: String,
      default () {
        return ''
      }
    }
  },
  mounted () {
    this.obtenerEspacio()
  },
  data () {
    return {
      espacio: null
    }
  },
  methods: {
    obtenerEspacio () {
      let vm = this

      Entidad.obtenerEspacio(vm.altaTurno).then(
        data => {
          vm.espacio = data
        },
        error => {
          console.log(error)
        }
      )
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
